import * as Sentry from '@sentry/browser'

import { NetworkSpecificDatabase } from '@/shared/Database/NetworkSpecific/NetworkSpecificDatabase'
import { useAppStore } from '@/popup/store/AppStore'
import { useUIStore } from '@/popup/store/UIStore'
import { UPSettingsDatabase } from '@/shared/Database/UPSettings/UPSettingsDatabase'
import { NetworkId } from '@/shared/models/Network'
import { LastPopupState } from '@/shared/models/Profile'

export let PopupDatabase: NetworkSpecificDatabase
export let GlobalDatabase: UPSettingsDatabase

const configureSentry = (networkId: NetworkId) => {
  Sentry.setTag('networkId', networkId)
}

export const initDatabase = async (networkId: NetworkId): Promise<void> => {
  PopupDatabase = await NetworkSpecificDatabase.load(networkId)
  GlobalDatabase = await UPSettingsDatabase.load()
  configureSentry(networkId)
}

export const switchPopupDatabase = async (
  networkId: NetworkId
): Promise<void> => {
  PopupDatabase.closeDatabase()
  PopupDatabase = await NetworkSpecificDatabase.load(networkId)
  configureSentry(networkId)
}

export const saveLastState = async (
  changes?: Partial<LastPopupState>,
  address?: string
): Promise<void> => {
  const profileAddress = address || useAppStore().selectedProfile

  if (profileAddress) {
    const uiStore = useUIStore()

    const currentTab = uiStore.currentTab
    try {
      if (uiStore.isExternalPopup) {
        // External popups shouldn't affect the state of a real popup
        return
      }
      await (changes
        ? PopupDatabase.saveLastPopupState(profileAddress, {
            ...changes,
            homeEdit: { tab: currentTab },
          })
        : PopupDatabase.removeLastPopupState(profileAddress))
    } catch (error) {
      delete (error as any)._promise // Allow this exception to work in jest
      throw error
    }
  }
}
